import { Proposal } from "@/models/proposal.model";
import { axiosInstanceConsignado, axiosInstanceFgts } from "./axiosInstance";
import { ProposalConsignado } from "@/models/proposalConsignado.model";

export const getLastFgtsProposalByDocumentId = async (
  hash?: string
): Promise<Proposal | null> => {
  try {
    if (!hash) return null;

    const proposalRes = await axiosInstanceFgts.get(
      `/api/proposal/unico/${hash}`
    );

    return proposalRes.data;
  } catch (error) {
    console.error("Erro ao obter o Proposta:", error);
    throw error;
  }
};

export const getLastConsignadoProposalByDocumentId = async (
  hash?: string
): Promise<ProposalConsignado | null> => {
  try {
    if (!hash) return null;

    const proposalRes = await axiosInstanceConsignado.get(
      `/api-consignado-trabalhador/v1/proposta/${hash}/minha-biometria`,
      { timeout: 60000 }
    );
    return proposalRes.data;
  } catch (error) {
    console.error("Erro ao obter o Proposta:", error);
    throw error;
  }
};

interface AcceptProposalRequest {
  telefone: string;
  email: string;
  id_financial_info: string;
  id_insurance_info?: string | null;
  latitude?: number;
  longitude?: number;
  emailEmpresa?: string;
  telefoneEmpresa?: string;
}

export const acceptConsignadoProposal = async (
  proposalId: string,
  data: AcceptProposalRequest
): Promise<any> => {
  try {
    const response = await axiosInstanceConsignado.post(
      `/api-consignado-trabalhador/v1/proposta/${proposalId}/aceite-tomador`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao aceitar proposta:", error);
    throw error;
  }
};

export const enviarCodigoSeguranca = async (
  proposalId: string,
  telefone: string
): Promise<any> => {
  try {
    const response = await axiosInstanceConsignado.post(
      `/api-consignado-trabalhador/v1/proposta/${proposalId}/enviar-codigo-seguranca`,
      { telefone }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao enviar código de segurança:", error);
    throw error;
  }
};

export const validarCodigoSeguranca = async (
  proposalId: string,
  codigo: string
): Promise<any> => {
  const response = await axiosInstanceConsignado.post(
    `/api-consignado-trabalhador/v1/proposta/${proposalId}/validar-codigo-seguranca`,
    { codigo }
  );
  return response.data;
};

export type DocumentTermType = "contrato-ccb" | "apolice" | "termos-e-condicoes-gerais";

interface GetDocumentTermsParams {
  type: DocumentTermType;
  proposalId: string;
  financialInfoId: string;
  insuranceInfoId?: string;
}

export const getConsignadoDocumentTerms = async (
  params: GetDocumentTermsParams
): Promise<any> => {
  try {
    const queryParams = new URLSearchParams({
      type: params.type,
      proposalId: params.proposalId,
      financialInfoId: params.financialInfoId,
    });

    if (params.insuranceInfoId) {
      queryParams.append("insuranceInfoId", params.insuranceInfoId);
    }

    const response = await axiosInstanceConsignado.get(
      `/api-consignado-trabalhador/v1/document-terms`,
      {
        params: queryParams,
        responseType: 'blob'
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter documento de termos:", error);
    throw error;
  }
};



// export const getLastConsignadoProposalByDocumentId = async (
//   hash?: string
// ): Promise<ProposalConsignado | null> => {
//   try {
//     if (!hash) return null;

//     return {
//       cpf: "49045958074",
//       nome: "Nome do Trabalhador",
//       infromacoes_financeiras: [
//         {
//           id: "12345678901",
//           processorName: "BMP",
//           numeroParcelas: 6,
//           valorParcela: 100,
//           valorLiberado: 595.09,
//           valorTaxaMensal: 0.17,
//           valorSeguro: 100,
//           valorTotalDivida: 600,
//         },
//         {
//           id: "12345678900",
//           processorName: "BMP",
//           numeroParcelas: 6,
//           valorParcela: 100,
//           valorLiberado: 595.09,
//           valorTaxaMensal: 0.17,
//           valorSeguro: 100,
//           valorTotalDivida: 600,
//         },
//       ],
//       informacoes_seguro: {
//         id_empresa_seguradora: "427ff8fd-f700-4e19-b7a6-cf6415474107",
//         id_externo: "8426a2b2-cae3-4f3f-8f44-adad8dc4247d",
//         valor_seguro: 36,
//         valor_emprestimo: 600,
//         numero_parcelas: 6,
//       },
//     };

//     // const proposalRes = await axiosInstanceConsignado.get(
//     //   `/api-consignado-trabalhador/v1/proposta/${hash}/minha-biometria`
//     // );

//     // return proposalRes.data;
//   } catch (error) {
//     console.error("Erro ao obter o Proposta:", error);
//     throw error;
//   }
// };
